/* Theme toggle: light ↔ dark, persisted to localStorage under "op_theme".
   The pre-paint bootstrap script in default.hbs handles the initial render;
   this file binds the toggle button, syncs the label/glyph, and the keyboard shortcut.
*/

(function () {
  var STORAGE_KEY = 'op_theme';
  var html = document.documentElement;

  function currentTheme() {
    var attr = html.getAttribute('data-theme');
    if (attr === 'light' || attr === 'dark') return attr;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function syncToggle() {
    var t = currentTheme();
    var label = document.querySelector('[data-op-theme-label]');
    var glyph = document.querySelector('[data-op-theme-glyph]');
    // Label names the theme the button would switch TO.
    if (label) label.textContent = (t === 'dark') ? 'Light' : 'Dark';
    if (glyph) glyph.textContent = (t === 'dark') ? '◑' : '◐';
  }

  function applyTheme(next) {
    html.setAttribute('data-theme', next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch (e) {}
    syncToggle();
  }

  function toggle() {
    applyTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-op-theme-toggle]');
    if (target) {
      e.preventDefault();
      toggle();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 't' && e.key !== 'T') return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    toggle();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncToggle);
  } else {
    syncToggle();
  }
})();
